// extracted by mini-css-extract-plugin
module.exports = {"save-icon":"save-button__save-icon___LOGPr","text-add":"save-button__text-add___20GfE"};